/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Group_Waiting_BodyInputs */



/**
* | output |
* | --- |
* | "Blocked by something no one on this page can fix, so it is kept out of “Ready to invoice”." |
*
* @param {Partner_Billing_Board_Group_Waiting_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_group_waiting_body = /** @type {((inputs?: Partner_Billing_Board_Group_Waiting_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Group_Waiting_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Blockiert durch etwas, das niemand auf dieser Seite beheben kann, und daher nicht unter „Bereit zur Fakturierung“ aufgeführt.")
	return /** @type {LocalizedString} */ ("Blocked by something no one on this page can fix, so it is kept out of “Ready to invoice”.")
});